import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    return {
        entitiesSearch: null,
        entitiesSelectedCommunes: [],
        entitiesSelectedTags: [],
        canSearch: false,
        entitiesSelectedTourismSectors: [],
        entitiesEmailSearch: null,
    }
}

const entitiesFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setEntitiesSearch(state, value) {
            state.entitiesSearch = value
        },
        setEntitiesEmailSearch(state, value) {
            state.entitiesemailSearch = value
        },
        setEntitiesSelectedCommunes(state, value) {
            state.entitiesSelectedCommunes = value
        },
        setEntitiesSelectedTags(state, value) {
            state.entitiesSelectedTags = value
        },
        setEntitiesSelectedTourismSectors(state, value) {
            state.entitiesSelectedTourismSectors = value
        },
        setCanSearch(state, value) {
            state.canSearch = value
        },
    }
}

export default entitiesFilter